import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form"
export default class extends Controller {
	static targets = ["container", "template"]
	static values = {
		wrapperSelector: { type: String, default: "[data-nested-form-wrapper]" }
	}

	/** @param {Event} event */
	add(event) {
		event.preventDefault()

		const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
		this.containerTarget.insertAdjacentHTML("beforeend", content)

		this.dispatch("add", {
			detail: {
				element: this.containerTarget.lastElementChild
			}
		})
	}

	/** @param {Event} event */
	remove(event) {
		event.preventDefault()

		const element = event.target.closest(this.wrapperSelectorValue)
		element.remove()

		this.dispatch("remove", {
			detail: {
				element: element
			}
		})
	}
}
